import { computed } from '@preact/signals';

import { weatherPrayerFor, type WeatherPrayerMessages } from '@amumin/i18n';

import { locale } from '../state/session.js';

// Teksten voor locatie en weer in de ouderapp (packages/i18n weatherPrayer). De variant voor
// "waarom" en "wissen" kiest `used_by` van de server: zonder zichtbare gebedsmodule nooit het
// woord gebedstijden (DESIGN §8.G.1 punt 4).

// Golf 3: elke taal, met terugval op nl.
export const wp = computed<WeatherPrayerMessages>(() => weatherPrayerFor(locale.value));

export type GeoVariant = 'weather' | 'prayer' | 'both';

export function variantOf(usedBy: ReadonlyArray<string>): GeoVariant {
  const w = usedBy.indexOf('weather') >= 0;
  const p = usedBy.indexOf('prayer') >= 0;
  if (w && p) return 'both';
  if (p) return 'prayer';
  return 'weather';
}

/** "regenjas en laarzen" uit de woorden van de adviezen (zelfde regel als de server). */
export function joinItems(words: ReadonlyArray<string>, and: string): string {
  if (words.length <= 1) return words[0] ?? '';
  return `${words.slice(0, -1).join(', ')} ${and} ${words[words.length - 1]}`;
}
